import { TransactionsHistoryRequest, TransactionsLists } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchTransactionsHistory() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [transactions, setTransactions] = useState<TransactionsLists[]>([]);

  async function fetchTransactionsHistory(req: TransactionsHistoryRequest) {
    try {
      setFetching(true);

      const res = await api.fetchTransactionsHistory({
        ...req,
        Currency: req.Currency === 'All' ? undefined : req.Currency,
      });

      if (!res.Success) throw new Error(res.ErrorMessage);

      setTransactions(res.Transactions);
      // /account/transactions documents NumberOfRecords, not PaginationMetaData —
      // fall back to it rather than throwing when the pagination block is absent.
      setTotalRecords(res.PaginationMetaData?.TotalRecords ?? res.NumberOfRecords);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchTransactionsHistory, transactions, totalRecords };
}
